import { render, staticRenderFns } from "./columnProperties.vue?vue&type=template&id=77bb3d24&"
import script from "./columnProperties.vue?vue&type=script&lang=js&"
export * from "./columnProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports